import React from 'react';
import { motion } from 'framer-motion';

const plans = [
  {
    name: 'Pro Jednorazowy',
    price: '39',
    period: '/ jednorazowo',
    desc: 'Pełny dostęp do kreatora przez 30 dni. Opłać BLIKIEM.',
    features: [
      'Pełny dostęp do kreatora rzutów',
      'Nielimitowana liczba projektów',
      'Nielimitowany eksport do PNG',
      'Komercyjne wykorzystanie rzutów',
      'Biblioteka mebli i wyposażenia',
      'Dodawanie wymiarów i opisów',
      'Firmowe logo i znak wodny',
      'Wsparcie techniczne'
    ],
    cta: 'Wybierz plan',
    highlighted: false
  },
  {
    name: 'Pro Miesięczny',
    price: '29',
    period: '/ miesiąc',
    desc: 'Pełny dostęp do kreatora przez 30 dni. Rezygnujesz w dowolnej chwili.',
    features: [
      'Pełny dostęp do kreatora rzutów',
      'Nielimitowana liczba projektów',
      'Nielimitowany eksport do PNG',
      'Komercyjne wykorzystanie rzutów',
      'Biblioteka mebli i wyposażenia',
      'Dodawanie wymiarów i opisów',
      'Firmowe logo i znak wodny',
      'Wsparcie techniczne'
    ],
    cta: 'Rozpocznij teraz',
    highlighted: true,
    badge: 'Popularny'
  },
  {
    name: 'Pro Roczny',
    price: '299',
    period: '/ rok',
    desc: 'Najlepszy wybór dla biur nieruchomości. Oszczędzasz 49 zł rocznie.',
    features: [
      'Pełny dostęp do kreatora rzutów',
      'Nielimitowana liczba projektów',
      'Nielimitowany eksport do PNG',
      'Komercyjne wykorzystanie rzutów',
      'Biblioteka mebli i wyposażenia',
      'Dodawanie wymiarów i opisów',
      'Firmowe logo i znak wodny',
      'Wsparcie techniczne'
    ],
    cta: 'Wybierz plan',
    highlighted: false
  }
];

export default function Pricing() {
  const APP_URL = "https://app.rzutnieruchomosci.pl/";

  return (
    <section id="pricing" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-[40px] text-[#1F2937] tracking-tight mb-4">Proste i przejrzyste ceny</h2>
          <p className="text-lg text-gray-500 font-normal max-w-2xl mx-auto">
            Wszystkie plany oferują te same funkcje. Wybierz okres dostępu najlepiej dopasowany do swoich potrzeb.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-8 mb-12">
          {plans.map((plan, i) => (
            <motion.div 
              key={i}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className={`relative rounded-2xl border p-10 flex flex-col ${
                plan.highlighted 
                ? 'border-gray-900 bg-white shadow-attio-lg ring-1 ring-gray-900 z-10 scale-[1.02] md:scale-100 lg:scale-[1.02]' 
                : 'border-gray-200 bg-white'
              }`}
            >
              {plan.badge && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gray-900 text-white px-3 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wider">
                  {plan.badge}
                </div>
              )}
              
              <h3 className="text-2xl text-[#1F2937] mb-2">{plan.name}</h3>
              <p className="text-[14px] text-gray-500 mb-8 leading-relaxed h-10">{plan.desc}</p>
              
              <div className="mb-8 flex items-baseline gap-1">
                <span className="text-5xl text-[#1F2937] tracking-tight">{plan.price}</span>
                <span className="text-2xl text-[#1F2937] tracking-tight">zł</span>
                <span className="text-[14px] font-medium text-gray-500 ml-1">{plan.period}</span>
              </div>

              <div className="h-px bg-gray-100 w-full mb-8"></div>

              <ul className="space-y-4 mb-10 flex-1">
                {plan.features.map((feature, fi) => (
                  <li key={fi} className="flex items-start text-[14px] text-gray-600">
                    <div className="w-1.5 h-1.5 rounded-full bg-gray-300 mt-1.5 mr-3 shrink-0"></div>
                    {feature}
                  </li>
                ))}
              </ul>

              <a 
                href={APP_URL}
                className={`w-full py-3.5 rounded-lg text-[15px] font-semibold transition-all text-center ${
                  plan.highlighted 
                  ? 'bg-[#1F2937] text-white hover:bg-gray-800' 
                  : 'bg-white border border-gray-200 text-[#1F2937] hover:bg-gray-50 shadow-sm'
                }`}
              >
                {plan.cta}
              </a>
            </motion.div>
          ))}
        </div>

        <p className="text-center text-[13px] text-gray-400 font-normal">
          Do cen należy doliczyć 23% podatku VAT. Faktura wystawiana automatycznie po zakupie.
        </p>
      </div>
    </section>
  );
}